import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import useCancelTokenStore from "@/store/composables/cancel-token";
import http from "@/tools/http-client";
import {ref} from "vue";

export const useCartStore
    = defineStore('CartStore', () => {

    const crud = useCrudStore(environment.appConfig.baseApiUrl + "cart");


    const cancelTokenStore = useCancelTokenStore();
    const selectedIds = ref([]);
    let selectionInitialized = false;

    function setSelected(ids) {
        const cartItemIds = new Set(crud.items.value.map(item => item.id));
        selectedIds.value = [...new Set(ids)].filter(id => cartItemIds.has(id));
        selectionInitialized = true;
    }

    async function loadCart() {
        console.log("loadCart");
        crud.startLoading();
        try {
            const resp = await http.get(crud.endpoint.value + '/index?page=1&per_page=100');
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
            const cartItems = resp.data.cart_items || [];
            crud.setData(cartItems);
            if (selectionInitialized) {
                setSelected(selectedIds.value);
            } else {
                selectedIds.value = cartItems.map(item => item.id);
                selectionInitialized = true;
            }
        } catch (e) {
            crud.setError(e);
        }
    }
    async function addCart({price_list_item_id, comment, qnt, coin_id }) {
        crud.startLoading();
        try {
            const resp
                = await http.post(crud.endpoint.value + '/add', {price_list_item_id, comment, qnt, coin_id});
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
            crud.addItems([resp.data.item]);
            if (selectionInitialized) {
                setSelected([...selectedIds.value, resp.data.item.id]);
            }
        }catch (e) {
            crud.setError(e);
        }
    }
    async function deleteCart({ids}) {
        console.log("deleteCart");
        crud.startLoading();
        try {
            const resp
				= await http.delete(
                    crud.endpoint.value + '/del',
                {params: {id: ids}, paramsSerializer: {indexes: false}}
            );
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
            await  loadCart();
        } catch (e) {
            crud.setError(e);
        }
    }
    async function updateQnt({qnt, id}) {
        console.log("updateQnt");
        if(qnt < 1) {
            await deleteCart({ids: [id]})
            return;
        }
        cancelTokenStore.acquireToken();
        crud.startLoading();
        try {
            const resp
                = await http.post(
                crud.endpoint.value + '/upd',
                {qnt, id},
                {cancelToken: cancelTokenStore.cancelToken.value}
            );
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.clearLoading();
            const found = crud.items.value
                .find(item => item.id === resp.data.item.id);
            if(found){
                found.qnt = resp.data.item.qnt;
            }
        } catch (e) {
            crud.setError(e);
        }
    }

    return {
        ...crud,
        loadCart,
        addCart,
        deleteCart,
        updateQnt,
        selectedIds,
        setSelected
    }
});
